export default {
    path: "Comprehensive",
    name: "Comprehensive",
    component: () =>
        import ("@/layout/body.vue"),
    meta: [{
        title: "服务器设置",
        path: "/index/Comprehensive/Comprehensive",
        icon: "el-icon-setting",
        name: "Comprehensive",
    }, ],
    children: [{
        path: "Comprehensive",
        name: "Comprehensives",
        component: () =>
            import ("@/views/Comprehensive/Comprehensive.vue"),
        meta: {
            title: "服务器设置",
            parent: "综合设置",
        },
    }, ],
};